import { useEffect, useState } from 'react';
import usePreMining from './usePreMining';
import { useCapsule } from './useContract';
import { useGetEstimatedGas } from './useEstimateGas';
import user from 'stores/user';
import { getOnePieceServerApi } from 'gql-ops';

export default function useCapsuleGasFee(): [string, boolean] {
    const [estimateGasParam, setEstimateGasParam] = useState<any>(null);
    const { hasPreMined } = usePreMining();
    const capsule = useCapsule();
    const [gasFee, isLoaded] = useGetEstimatedGas({
        contract: capsule,
        method: 'mint',
        params: estimateGasParam,
        show: true,
        fetch: estimateGasParam !== null,
    });

    useEffect(() => {
        const getParams = async () => {
            const permit = (
                await getOnePieceServerApi().capsuleMintPermit({
                    address: user.address,
                })
            )?.capsuleMintPermit.permit;
            if (permit) {
                const p = JSON.parse(permit);
                setEstimateGasParam([user.address, hasPreMined, [p.permitType, p.nonce, p.dataHash, p.expire, p.sig]]);
            }
        };
        getParams();
    }, []);
    return [gasFee, isLoaded];
}
